import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { Box, styled, useTheme } from "@mui/material";

import { usePlayer } from "@/components/player";
import { useAuth } from "@/providers";
import { AppRoutes } from "@/routes";

const StyledMask = styled(Box)(({ theme }) => {
  return {
    left: theme.spacing(0),
    pointerEvents: "none",
    position: "fixed",
    right: theme.spacing(0),
    zIndex: theme.zIndex.appBar - 1,
  };
});

export const Mask = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const { player } = usePlayer();
  const { user } = useAuth();

  const { AUTH, EMAIL_LINK, ROOT, SIGN_IN, SIGN_UP } = AppRoutes;

  const bgo = theme.palette.background.default;
  const bgt = theme.alpha(bgo, 0);

  const showTopMask = useMemo(() => {
    // always when user logged in
    if (user) return true;
  }, [user]);

  const showBottomMask = useMemo(() => {
    // never on auth pages
    if ([AUTH(), SIGN_IN(), SIGN_UP(), EMAIL_LINK()].includes(pathname))
      return false;
    // never on the home page
    if ([ROOT()].includes(pathname)) return false;
    // always when story playing
    if (player.story) return true;
    // always when user logged in
    if (user) return true;
  }, [AUTH, EMAIL_LINK, ROOT, SIGN_IN, SIGN_UP, pathname, player.story, user]);

  return (
    <>
      {showTopMask && (
        <StyledMask
          sx={{
            backgroundImage: `linear-gradient(${bgo} 50%, ${bgt} 100%) `,
            displayPrint: "none",
            height: `calc(env(safe-area-inset-top) + ${theme.spacing(10)})`,
            top: 0,
          }}
        />
      )}
      {showBottomMask && (
        <StyledMask
          sx={{
            backgroundImage: `linear-gradient(${bgt} 0%, ${bgo} 50%)`,
            bottom: 0,
            displayPrint: "none",
            height: `calc(env(safe-area-inset-bottom) + ${theme.spacing(player.story ? 20 : 16)})`,
          }}
        />
      )}
    </>
  );
};
